import React from 'react';
import { Link } from 'react-router-dom';
import './PoliciesPage.css';
import SEOHead from '../components/SEOHead';
import { getSEOConfig } from '../utils/seoConfig';

const PoliciesPage: React.FC = () => {
  const policies = [
    {
      category: 'Essential Policies',
      items: [
        {
          title: 'Privacy Policy',
          description: 'Learn how we collect, use, and protect your personal information.',
          link: '/privacy'
        },
        {
          title: 'Terms of Use',
          description: 'Understand the rules and guidelines for using GelWel.',
          link: '/terms'
        },
        {
          title: 'Cookie Policy',
          description: 'Information about how we use cookies and tracking technologies.',
          link: '/cookies'
        }
      ]
    },
    {
      category: 'Security & Privacy',
      items: [
        {
          title: 'Security Policy',
          description: 'Our commitment to keeping your data safe and secure.',
          link: '/security'
        },
        {
          title: 'Consent Policy',
          description: 'How we obtain and manage your consent for data processing.',
          link: '/consent'
        }
      ]
    },
    {
      category: 'Community Guidelines',
      items: [
        {
          title: 'Community Policies',
          description: 'Guidelines for content, safety, and maintaining a positive community.',
          link: '/community-policies'
        }
      ]
    },
    {
      category: 'Support',
      items: [
        {
          title: 'Account & Support',
          description: 'Information about account deletion and customer service.',
          link: '/account-support'
        }
      ]
    }
  ];

  const seoConfig = getSEOConfig('/policies');

  return (
    <>
      <SEOHead
        title={seoConfig.title}
        description={seoConfig.description}
        keywords={seoConfig.keywords}
        ogType={seoConfig.ogType}
      />
      <div className="policies-page">
        <div className="policies-container">
          <nav className="policies-breadcrumb">
            <Link to="/" className="policies-breadcrumb-link">Home</Link>
            <span className="policies-breadcrumb-separator">/</span>
            <span className="policies-breadcrumb-current">Policies</span>
          </nav>

          <div className="policies-header">
            <h1 className="policies-title">Legal & Policy Center</h1>
            <p className="policies-subtitle">
              Your privacy and safety are our top priorities. Review our policies to understand how we protect and serve our community.
            </p>
          </div>

          <div className="policies-grid">
            {policies.map((category, idx) => (
              <div key={idx} className="policies-category">
                <h2 className="policies-category-title">{category.category}</h2>
                <div className="policies-cards">
                  {category.items.map((policy, policyIdx) => (
                    <Link key={policyIdx} to={policy.link} className="policy-card">
                      <h3 className="policy-card-title">{policy.title}</h3>
                      <p className="policy-card-description">{policy.description}</p>
                      <span className="policy-card-arrow">→</span>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="policies-contact">
            <h2 className="policies-contact-title">Questions or Concerns?</h2>
            <p className="policies-contact-text">
              If you have any questions about our policies or need assistance, please contact us at{' '}
              <a href="mailto:paulfortuneltd@gmail.com" className="policies-contact-email">
                paulfortuneltd@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PoliciesPage;
